import React, { ChangeEvent } from 'react';
import Input from '../Shared/Input';
import styles from './CreateAccount.module.css';
import { ICreateAccount } from '../../../../interfaces';
import { handleTrackEmailInput, handleTrackInput } from '../../../utils/segment';

const CreateAccount = ({ email, password, handleOnChange }: ICreateAccount) => {
  // Analytics fired on GTB
  const onBlurEmail = (event: ChangeEvent<HTMLInputElement>) => {
    handleTrackInput(event);
    if (event.target.name === 'email' && event.target.value) {
      handleTrackEmailInput();
    }
  };

  return (
    <section className={styles.createAccount}>
      <div className={styles.createAccountHeaderWrapper}>
        <h3 className={styles.createAccountHeader}>Create Account</h3>
      </div>
      <form>
        <Input
          label="Email"
          value={email}
          handleInput={handleOnChange}
          onBlur={onBlurEmail}
          name="email"
          type="text"
          hasMargin
          errorMessage="Please enter a valid email."
        />
        <Input
          label="Password"
          value={password}
          handleInput={handleOnChange}
          name="password"
          type="password"
          errorMessage="Please enter a valid password."
        />
      </form>
    </section>
  );
};

export default CreateAccount;
